export default "__VITE_ASSET__BxxQBuKo__"